import { MealData } from '../index'

export default function GetMealDataFunc(mealId: any) {
  return MealData(mealId)
}
